import script from "./TopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=3ade7e34&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ade7e34"]])

export default __exports__